import { Button, CircularProgress, FormControl, Grid, makeStyles, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Search from "../grnReceipts/Search";
import CachedIcon from '@material-ui/icons/Cached';
import moment from "moment";
import clsx from 'clsx';
import AddIcon from '@material-ui/icons/Add';
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjects } from "../../../containers/actions/common/projectActions";
import EditIcon from '@material-ui/icons/Edit';
import { Pagination } from "@material-ui/lab";
import { ALL_PROJECTS_TABLE } from "../../../containers/actions/types";
import {  presentFormatedData } from "../functionalComponents/dataFormatFunctions";
import PaginationInput from "../models/pagination/PaginationInput";

const useStyles = makeStyles((theme) => ({

  refreshContainerSty:{display: 'flex', justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      paddingTop: '1rem',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: '1rem',
    },
  },
  refreshSty:{display: 'flex',alignItems: 'center',cursor: 'pointer','&:hover': {
    textDecoration: 'underline',
  }},
  padR20: {
    paddingRight: 20,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  hgText: {
    fontWeight: 500,
    paddingRight: theme.spacing(1),
  },
  outlined: {
    padding: theme.spacing(1),
  },
  formControl: {
    minWidth: 120,
    fontSize: '0.875rem',
  },
  formPerPage: {
    minWidth: 60,
    fontSize: '0.875rem',
  },
  upload: {
    background:
      'transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;',
    color: 'white',
    textTransform: 'none',
    borderRadius: '2rem',
    // marginRight: 20,
    padding: '5px 20px',
    '&:hover': {
      backgroundColor: 'green',
      background: 'green',
      color: 'white',
    },
  },
  multipleLogo: {
    border: '1px solid #7d7c7c',
    borderRadius: '4px',
    padding: '0.3rem',
    height: 'inherit',
    marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
      border: '1px solid #FFF',
    },
  },
  clickableTextSty: {
    '&:hover': {
      textDecoration: 'underline',
    color: '#2196F3',
    cursor: 'pointer'
    },
  }
}))

const ProjectsDashboard = () => { 
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [searchQuery, searchQueryInput] = useState('');
  const [tempSearch, tempSearchQury] = useState('');
  const [noRowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState('')
  let loading = true;

  useEffect(() => {
    // Fetch projects from API
    dispatch({
      type: ALL_PROJECTS_TABLE,
      payload: undefined
    })
    dispatch(fetchProjects());
  }, [dispatch]);

  const handleRefresh = () => {
    dispatch({
      type: ALL_PROJECTS_TABLE,
      payload: undefined
    })
    setError('');
    loading = true;
    dispatch(fetchProjects());
  }


  const handleSearchQuery = (event) => {
    let { value } = event.target;
    // if (value === '' || value === null) {
    //   tempSearchQury(value);
    //   searchQueryInput('');
    // } else {
    //   tempSearchQury(value);
    // }
  };

  const handleClearSearch = (event) => {
    event.preventDefault();
    tempSearchQury('');
    searchQueryInput('');
  };

  const submitSearch = (event) => {
    event.preventDefault();
    searchQueryInput(tempSearch.trim());
  };

  const handleSetRows = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  const openProjectDetails = (row) => {
    let projectName = row.projectName;
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/project/${projectName}`,
      {
        project: row,
      }
    );
  };

  const formatData = (data) => {
    const groupedData = {};
  
    data.forEach((item) => {
      const { collabrixProjectID, drugTarget, projectName,sponsorOrgID, cdmoOrgID } = item;
  
      const key = `${collabrixProjectID}-${drugTarget}`;
  
      if (!groupedData[key]) {
        groupedData[key] = {
          collabrixProjectID,
          projectName,
          drugTarget,
          sponsorOrgID,
          cdmoOrgID,
          projectRow: [],
        };
      }
  
      // Push the deliverable in the required format
      groupedData[key].projectRow.push({
        ...item,
        deliverableTypesList: item.deliverableTypesList,
        cdmoOrgID: item.cdmoOrgID,
        cdmoOrgName: item.cdmoOrgName,
        sponsorOrgID: item.sponsorOrgID,
        sponsorOrgName: item.sponsorOrgName,
        deliveryDate: item.deliveryDate,
        deliverablesCount: item.deliverablesCount,
        projectStatus: item.projectStatus,
      });
    });
  
    // Convert groupedData object back to an array
    return Object.values(groupedData);
  };


  // Function to render projectStatus button with correct color based on projectStatus
  let rows = useSelector((state) => {
    if (state.pcmp.common.Projects?.allProjects?.status === true) {
      if (loading) {
        loading = false
      }
      return state.pcmp.common.Projects.allProjects.data
    } else if (state.pcmp.common.Projects?.allProjects?.status === false) {
      if (loading) {
        loading = false
      }
      if (error === '') {
      setError('Something went wrong. Please try again later.')
      }
      return [];
     }
    else {
      return [];
    }
  });
  
  let totalPages = Math.ceil(rows.length / noRowsPerPage);

  let records = currentPage * noRowsPerPage;

  const projectsList = rows
  ? formatData(rows.slice(records - noRowsPerPage, records))
  : [];

let pages = rows
  ? Math.ceil(rows.length / noRowsPerPage)
  : null;

  let noPages = pages ? pages : 1;
  
  const renderprojectStatus = (projectStatus) => {
    let color;
    switch (projectStatus) {
      case 'Ongoing':
        color = '#FFA500'; // bright orange
        break;
      case 'Completed':
        color = '#4CAF50'; // green
        break;
      case 'Awaiting Start':
        color = '#A9A9A9'; // dark grey
        break;
      default:
        color = '#000';
    }
    return (
      <Typography variant='body1' style={{textAlign: 'center',
        padding: '0.25rem',
        borderRadius: '0.45rem',
        fontSize: '0.875rem',color: 'white',
        backgroundColor: color,
        border: `2px solid ${color}`,
      whiteSpace:'nowrap'}}>
        {projectStatus}
      </Typography>
    );
  };

  return (
    <React.Fragment>
      <Grid container item justifyContent="flex-end">
      <Button
              startIcon={<AddIcon />}
              // onClick={() => {
              //   setOpenUploadDSBatch(true);
              // }}
              className={classes.upload}
            >
              Add New Project
            </Button>
      </Grid>
      <Grid container alignItems='center' >
        <Grid item xs={12} sm={10} md={6}>
        <Typography variant='body2' style={{fontWeight: 500}}>
          Filter By:
        </Typography>
          <Search
            searchQuery={tempSearch}
            handleSearchQuery={handleSearchQuery}
            handleClearSearch={handleClearSearch}
            submitSearch={submitSearch}
            disabled={true}
            placeholder={`Search using Compound ID, ${ localStorage.collabType === 'CMO' ? 'Sponsor Name':'CMO'}`}
          />
          </Grid>
        <Grid item xs={12} md={6}>
          <Grid
            container
            className={classes.refreshContainerSty}
          >
            <Typography variant='caption' className={clsx(classes.padR20)}>
              {`Last synced @ ${moment(new Date()).format(
                'HH:mm:ss; DD MMMM, YYYY'
              )}`}
            </Typography>

            <Typography
              variant='caption'
              color='primary'
              className={classes.refreshSty}
              onClick = {handleRefresh}
            >
              Refresh
              <CachedIcon color='primary' style={{ fontSize: 15 }} />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container alignItems='center' justifyContent="flex-end" >
        <Grid item>
        <Typography variant='body2' className={classes.hgText}>
        PER PAGE
      </Typography>
      <FormControl className={classes.formPerPage}>
        <Select
          labelId='perpage-filter'
          id='perpage-filter-id'
          value={noRowsPerPage}
          variant='outlined'
          onChange={handleSetRows}
          classes={{
            outlined: classes.outlined,
          }}
        >
          <MenuItem value={3}>3</MenuItem>
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={15}>15</MenuItem>
          <MenuItem value={30}>30</MenuItem>
        </Select>
      </FormControl>
        </Grid>
      </Grid>
      <TableContainer component={Paper} style={{ marginTop: 20,maxHeight: 500 }}>
        <Table stickyHeader>
          <TableHead >
            <TableRow style={{ backgroundColor: "#F9F9FC" }}>
              <TableCell align="left">Compound ID</TableCell>
              <TableCell align="left">Drug Target</TableCell>
              <TableCell align="left">{localStorage.collabType === 'CMO' ? 'Sponsor':'CMOs'}</TableCell>
              <TableCell align="left">Deliverable Type</TableCell>
              <TableCell align="left">Delivery Date</TableCell>
              <TableCell align="right">Deliverables</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loading === true && (
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={8}>
                      <div style={{ textAlign: 'center' }}>
                        <CircularProgress color='primary' />
                      </div>
                    </TableCell>
                  </TableRow>
                )}
            {loading === false && error === '' && (projectsList.length > 0 ? projectsList.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
              <TableRow >
                <TableCell align="left" style={{ borderBottom: row.projectRow.length > 1 && 'none'}}>
                  <div onClick={()=> openProjectDetails(row)} className={classes.clickableTextSty}>
                    {presentFormatedData(row.projectName)}
                  </div>
                </TableCell>
                <TableCell align="left" style={{ borderBottom: row.projectRow.length > 1 && 'none'}}>{presentFormatedData(row.drugTarget)}</TableCell>
                <TableCell align="left">{localStorage.collabType === 'CMO' ? presentFormatedData(row.projectRow[0].sponsorOrgName) :presentFormatedData(row.projectRow[0].cdmoOrgName) }</TableCell>
                <TableCell align="left">
                  {row.projectRow[0].deliverableTypesList.length > 0 ? row.projectRow[0].deliverableTypesList.filter((value, index, self) =>
  index === self.findIndex((t) => (
    t.deliverableTypeID === value.deliverableTypeID && t.deliverableTypeName === value.deliverableTypeName
  ))
).map((type, i) => (
                    <div key={i} style={{ whiteSpace: 'nowrap' }}>
                      • {type.deliverableTypeName}
                    </div>
                  )):' - '}
                </TableCell>
                <TableCell align="left">{row.projectRow[0]?.deliveryDate ? moment(row.projectRow[0].deliveryDate).format('DD-MMM-YYYY').toUpperCase():' - '}</TableCell>
                <TableCell align="right">{presentFormatedData(row.projectRow[0].deliverablesCount)}</TableCell>
                <TableCell align="center">{renderprojectStatus(row.projectRow[0].projectStatus)}</TableCell>
                <TableCell align="center"><EditIcon
        fontSize='small'
        className={classes.multipleLogo}
      /></TableCell>
                </TableRow>
                {row.projectRow.slice(1).map((val, index) => (
                  <TableRow key={index}>
                    <TableCell align="left" style={{borderBottom: row.projectRow.length > index + 2 &&'none'}}></TableCell>
                    <TableCell align="left" style={{borderBottom: row.projectRow.length > index + 2 &&'none'}}></TableCell>
                    <TableCell align="left" style={{borderBottom: row.projectRow.length > index + 2 &&'none'}}>{localStorage.collabType === 'CMO' ? presentFormatedData(val.sponsorOrgName) :presentFormatedData(val.cdmoOrgName) }</TableCell>
                <TableCell align="left">
                  {val.deliverableTypesList.length > 0 ? val.deliverableTypesList.filter((value, index, self) =>
  index === self.findIndex((t) => (
    t.deliverableTypeID === value.deliverableTypeID && t.deliverableTypeName === value.deliverableTypeName
  ))
).map((type, i) => (
                    <div key={i} style={{ whiteSpace: 'nowrap' }}>
                      • {type.deliverableTypeName}
                    </div>
                  )):' - '}
                </TableCell>
                <TableCell align="left">{val?.deliveryDate ? moment(val.deliveryDate).format('DD-MMM-YYYY').toUpperCase():' - '}</TableCell>
                <TableCell align="right">{presentFormatedData(val.deliverablesCount)}</TableCell>
                <TableCell align="center">{renderprojectStatus(val.projectStatus)}</TableCell>
                <TableCell align="center"><EditIcon
        fontSize='small'
        className={classes.multipleLogo}
      /></TableCell>
                  </TableRow>
                ))}
                </React.Fragment>
            )): <TableRow>
            <TableCell
              colSpan={8}
              align='center'
            >
              No Records Found
            </TableCell>
            </TableRow>)}
            {loading === false && error !=='' && (<TableRow style={{border: '2px solid #FF0000',
                backgroundColor: '#FFF0F0',}}><TableCell
              colSpan={8}
              align='center'
              
            >
              Something went wrong. Please try again later.
            </TableCell>
            </TableRow>)}
          </TableBody>
        </Table>
      </TableContainer>
      <Grid
          container
          alignItems='center'
          justifyContent='center'
          style={{ paddingTop: '1rem' }}
        >
          {/* <Pagination
            page={currentPage}
            name='currentPage'
            onChange={(event, page) => handlePageChange(event, page)}
            count={noPages}
            variant='outlined'
            shape='rounded'
          /> */}
        <PaginationInput
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          page={currentPage}
        />
        </Grid>

    </React.Fragment>
  );
};

export default ProjectsDashboard;
